import { OverlayHistorySync } from "restaumatic-client/src/overlay/OverlayHistorySync";
import { OverlayStack } from "restaumatic-client/src/overlay/OverlayStack";
import { OverlayFocusManager } from "./OverlayFocusManager";
import { BootstrapModalBridge } from "./BootstrapModalBridge";
let infra = null;
/** Call once on sites from `app.js` (DOMContentLoaded). */
function init() {
    if (infra !== null)
        return;
    const overlayStack = new OverlayStack();
    const historySync = new OverlayHistorySync(overlayStack);
    historySync.start();
    const bsModalBridge = new BootstrapModalBridge(overlayStack);
    bsModalBridge.start();
    const focusManager = new OverlayFocusManager(overlayStack);
    focusManager.start();
    infra = { overlayStack };
}
/** Mobile app does not support history sync to work correctly with the current client side routing */
function initForMobileApp() {
    if (infra !== null)
        return;
    const overlayStack = new OverlayStack();
    const bsModalBridge = new BootstrapModalBridge(overlayStack);
    bsModalBridge.start();
    const focusManager = new OverlayFocusManager(overlayStack);
    focusManager.start();
    infra = { overlayStack };
}
/** Get the shared overlay instances. Throws if called before init. */
function getOverlayInfra() {
    if (infra === null) {
        throw new Error("Overlay infrastructure not initialized. Call init() or initForMobileApp() first.");
    }
    return infra;
}
export default {
    init,
    initForMobileApp,
    getOverlayInfra,
};
